import { format, parseISO } from "date-fns"
import type { Num, StockStatus } from "./types"

/** A decimal from the API (a number or a numeric string) as a number; blank is 0. */
export function num(value: Num | null | undefined): number {
  if (value === null || value === undefined || value === "") return 0
  const parsed = typeof value === "number" ? value : parseFloat(value)
  return isNaN(parsed) ? 0 : parsed
}

/** Whole units with thousands separators: `509,091`. */
export function fmt_qty(value: Num | null | undefined): string {
  return Math.round(num(value)).toLocaleString("en-US")
}

/** Dollars, cents dropped above $1,000: `$1,422,986`, `$514.80`. */
export function fmt_money(value: Num | null | undefined): string {
  const n = num(value)
  const digits = Math.abs(n) >= 1000 ? 0 : 2
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits })
}

/** `2026-10-01` → `Oct 2026`. */
export function month_label(iso: string): string {
  return format(parseISO(iso), "MMM yyyy")
}

/** `2026-11-03` → `Nov 3, 2026`. */
export function day_label(iso: string): string {
  return format(parseISO(iso), "MMM d, yyyy")
}

export const STATUS_LABEL: Record<StockStatus, string> = {
  out: "Out of stock",
  low: "Low",
  ok: "OK",
  over: "Overstock (> 12 wks)",
}

export const STATUS_CLASS: Record<StockStatus, string> = {
  out: "bg-red-100 text-red-800",
  low: "bg-amber-100 text-amber-800",
  ok: "bg-green-100 text-green-800",
  over: "bg-blue-100 text-blue-800",
}

/** The change from `before` to `after` as `+12` / `-3` / `0`. */
export function fmt_change(after: number, before: number): string {
  const change = after - before
  return change > 0 ? `+${change.toLocaleString("en-US")}` : change.toLocaleString("en-US")
}
